import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { FC, useState } from 'react';
import { Box, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, IconButton, Dialog, DialogTitle, DialogContent, Chip, Button, FormControlLabel, Checkbox, CircularProgress, Pagination } from '@mui/material';
import { palette } from 'src/theme/style/palette';
import { P2pHeader } from './P2pHeader';

interface Props {
    pos?: string
}

export const AddNewAdsButton: FC<Props> = ({ pos = 'absolute' }) => {
    const [openModalAds, setOpenModalAds] = useState<boolean>(false);

    const updateStateModal = () => setOpenModalAds(!openModalAds);

    return (
        <>

            <Box display='flex' justifyContent='end' sx={{ position: pos, top: pos == 'relative' ? '0' : '0.5rem', right: pos == 'relative' ? '0' : '0.5rem', zIndex: 1 }}>
                <Button variant='contained'
                    onClick={() => setOpenModalAds(true)}
                    sx={{ fontSize: '1.3rem !important' }}>ПРОДАТЬ</Button>
            </Box>

            <Dialog
                fullScreen
                fullWidth={true}
                maxWidth='lg'
                open={openModalAds}
                onClose={() => setOpenModalAds(false)}
            >
                <IconButton sx={{ background: palette.errorLight, position: 'absolute', top: '.5rem', right: '.5rem' }} onClick={() => setOpenModalAds(false)}>
                    <CloseRoundedIcon sx={{ color: palette.error }} />
                </IconButton>
                <DialogTitle>
                    Объявление о продаже
                </DialogTitle>
                <DialogContent sx={{ position: 'relative' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: "center", minHeight: '300px' }}>
                        <P2pHeader updateStateModal={updateStateModal} />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}
